<template>
  <div class="modal-content-virtual-member">
    <div class="modal-header">
      <h2>Kreiranje novog stanara</h2>
    </div>
    <div class="body">
      <form action="post">
        <!-- <div class="input-wrapper">
          <div class="user--mod relative">
            <label class="col-form-label col-form-label-lg"
              >Poveži sa korisnikom aplikacije</label
            >
            <model-select
              ref="member"
              :options="options"
              v-model="selectedMember"
              placeholder="
            Stanar"
              class="add-member-dropdown"
            ></model-select>
          </div>
        </div> -->
        <div id="first-section">
          <label class="col-form-label col-form-label-lg">
            Ime i prezime
            <span class="mandatory">*</span>
          </label>
          <input
            class="form-control"
            rows="4"
            placeholder="Unesite ime i prezime"
            v-model.trim="fullName"
            @focus="errorOccurred = false"
          />
          <label class="col-form-label col-form-label-lg tooltip-label">
            Opis posebnog dela
            <span class="mandatory">*</span>
            <!-- <span class="popover" rel="popover" data-placement="top">
              <i
                class="fas fa-info-circle"
                title="Svaki poseban deo koji dodate ovim putem posmatra se kao poseban stanar"
              ></i>
            </span> -->
          </label>
          <div
            class="desc-wrapper"
            v-for="(desc, index) in descriptionList"
            :key="index"
          >
            <input
              class="form-control"
              rows="4"
              placeholder="Unesite opis posebnog dela (npr. stan 4, garaža 12)"
              v-model.trim="desc.value"
              @focus="errorOccurred = false"
            />
            <span
              class="btn btn-primary"
              v-if="index != 0"
              @click="removeDesc(desc)"
            >
              <i class="fas fa-minus"></i>
            </span>
          </div>
          <!-- <div class="btn btn-primary btn-add-desc" @click="addAnotherDesc">
            <span>Dodajte još jedan poseban deo</span>
            <i class="fas fa-plus"></i>
          </div> -->

          <label class="col-form-label col-form-label-lg">Email</label>
          <input
            class="form-control"
            rows="4"
            placeholder="Unesite email"
            v-model.trim="email"
            @focus="errorOccurred = false"
          />
          <label class="col-form-label col-form-label-lg">
            Broj telefona
          </label>
          <input
            class="form-control"
            rows="4"
            placeholder="Unesite broj telefona"
            v-model.trim="phoneNumber"
            @focus="errorOccurred = false"
          />

          <label class="col-form-label col-form-label-lg"
            >Površina <span class="mandatory">*</span>
          </label>

          <input
            class="form-control"
            rows="4"
            placeholder="Unesite površinu"
            @focus="errorOccurred = false"
            v-model.lazy="areaSize"
            type="number"
          />
        </div>
      </form>
    </div>

    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          :disabled="loading"
          @click="editAccount"
        >
          <p v-if="!loading">Dodaj novog stanara</p>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { financesInstance } from '@/axios/axios.js';
import { ModelSelect } from 'vue-search-select';
import axios from '@/axios/axios.js';
import { utilService } from '@/util/UtilService.js';

export default {
  data() {
    return {
      errorOccurred: false,
      errorMessage: '',
      fullName: '',
      divDescription: '',
      phoneNumber: '',
      phoneNumberValid: null,
      email: '',
      areaSize: null,
      memberId: null,
      selectedMember: null,
      members: [],
      loading: false,
      descriptionList: [{}]
    };
  },
  computed: {
    options() {
      let members = [];
      members.push({
        value: null,
        text: 'Bez izabranog stanara'
      });
      let realMembers = this.members.map(e => {
        return { value: e.id, text: `${e.user_full_name} - ${e.email}` };
      });
      members.push(...realMembers);
      return members;
    }
  },
  watch: {
    selectedMember: function() {
      this.updateMemberFields();
    }
  },
  async created() {
    axios
      .post('member/get-members-by-community', {
        community_id: this.$route.params.id,
        active: 1
      })
      .then(({ data }) => {
        this.members = data;
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('table', ['getAllMembersForCommunityFinances']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations('finances', ['setVirtualMembersList']),
    updateMemberFields() {
      this.members.forEach(e => {
        if (e.id === this.selectedMember) {
          this.fullName = e.user_full_name;
          this.descriptionList = [{ value: e.div_desc }];
          this.email = e.email;
        }
      });
    },
    addAnotherDesc() {
      this.descriptionList.push({});
    },
    removeDesc(desc) {
      this.descriptionList = this.descriptionList.filter(d => d != desc);
    },
    editAccount() {
      this.errorOccurred = false;
      if (!this.validateInput()) {
        this.errorOccurred = true;
        return;
      }
      this.loading = true;
      // const newBalance = parseFloat(
      //   parseFloat(this.balance.replace(/,/g, '')).toFixed(2)
      // );
      this.descriptionList = this.descriptionList.map(desc => {
        return desc.value;
      });
      let virtualMemberData = {
        fullName: this.fullName,
        email: this.email,
        divDescriptions: this.descriptionList,
        memberId: this.selectedMember,
        areaSize: this.areaSize,
        phoneNumber: this.phoneNumber
      };
      financesInstance
        .post(`communities/${this.$route.params.id}/member`, virtualMemberData)
        .then(async () => {
          const virtualMembers = await this.getAllMembersForCommunityFinances(
            this.$route.params.id
          );
          this.setVirtualMembersList(virtualMembers);
          this.loading = false;
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.showFailModal();
        });
    },
    validateInput() {
      if (this.fullName == '') {
        this.errorMessage = 'Morate uneti ime i prezime';
        return false;
      }
      if (
        this.descriptionList.length == 0 ||
        this.descriptionList.find(d => !d.value || d.value === '')
      ) {
        this.errorMessage = 'Morate popuniti sva polja za opis posebnog dela';
        return false;
      }
      if (this.descriptionList.find(d => d.value.length > 250)) {
        this.errorMessage =
          'Opis posebnog dela ne može imati preko 250 karaktera';
        return false;
      }

      if (
        this.email &&
        this.email != '' &&
        !utilService.isEmailValid(this.email)
      ) {
        this.errorMessage = 'Morate uneti ispravnu email adresu';
        return false;
      }
      if (this.email && this.email != '' && this.email.length > 250) {
        this.errorMessage = 'Email adresa ne može imati preko 250 karaktera';
        return false;
      }
      if (this.areaSize == null || !this.areaSize || isNaN(this.areaSize)) {
        this.errorMessage = 'Morate uneti površinu';
        return false;
      }

      return true;
    }
  }
};
</script>

<style lang="scss">
.user--mod {
  .text {
    max-width: calc(100% - 30px) !important;
  }
}
.modal-content-virtual-member {
  .input-wrapper {
    display: flex;
    width: 100%;
    position: relative;
    .user--mod {
      width: 100%;
      z-index: 5;
      margin-bottom: 2rem;
      input {
        margin-bottom: 0;
      }
      .ui.fluid.search {
        width: 100%;
        line-height: 1.5;
        border-radius: 0.3rem;
        border: 1px solid #ced4da;
        font-size: 1rem;
        color: #495057;
        transition: 0.2s all;
        height: calc(2.25rem + 2px);

        input {
          border: none;
          padding: 0.5rem 1rem;
          font-size: 1rem;
          line-height: 1;
          max-width: 100%;
        }

        input:focus {
          border: none;
          outline: none;
          & {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
        .text {
          position: absolute;
          top: 7px;
          left: 1rem;
          color: #5f5f5f;
          font-size: 1rem;
        }
        .menu {
          border: 1px solid #ced4da;
          border-radius: 0.3rem;
          border-top-width: 0;
          border-top-right-radius: 0;
          border-top-left-radius: 0;
          z-index: 11;
          background-color: white;
          max-height: 10rem;
          overflow-y: auto;
          margin: -5px -1px 0px -1px;
          .item {
            z-index: 15;
          }
          .item:hover {
            background-color: rgba(0, 0, 0, 0.05);
            cursor: pointer;
          }

          .item.selected {
            background-color: rgba(0, 0, 0, 0.178);
          }

          .btn--add {
            width: 100%;
          }
        }
      }
    }
    .add-member-dropdown {
      .menu {
        max-height: 10rem !important;
      }
    }

    .amount--mod {
      width: 100%;
      margin-bottom: 2rem;
    }

    .input-span {
      position: absolute;
      font-size: 1.5rem;
      color: rgb(95, 95, 95);
      top: 0.5rem;
      pointer-events: none;
      transition: 0.2s all;
      left: 1rem;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input {
      margin-right: 15px;
    }

    .input--:focus ~ .input-span--name,
    .input--name:not(:placeholder-shown) ~ .input-span--name {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
      // opacity: 0;
    }

    .input--amount:focus ~ .input-span--amount,
    .input--amount:not(:placeholder-shown) ~ .input-span--amount {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
    }

    .relative {
      position: relative;
    }
  }

  .body {
    height: 100%;
    width: 100%;
  }

  input {
    margin-bottom: 9px;
    position: relative;
  }

  .btn-add-desc {
    i {
      margin-left: 4px;
    }
  }

  .desc-wrapper {
    display: flex;
    justify-content: space-between;
    span {
      margin-bottom: 9px;
      margin-left: 8px;
      min-width: 60px;
    }
  }

  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }

  .buttons {
    display: inline-flex;
    float: right;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .btn-primary:hover {
    background-color: var(--primary-color-lighten);
  }

  .btn-primary:active {
    background-color: var(--primary-color) !important;
    border: none;
  }

  .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
  }

  .error {
    float: left;
    margin-left: 15px;
  }

  .err-msg {
    text-align: center;
    color: red;
  }

  .col-form-label-lg {
    width: 100%;
    position: relative;
  }

  .mandatory {
    color: red;
  }

  label.tooltip-label {
    display: flex;
    .mandatory {
      margin-left: 4px;
    }
    .popover {
      position: relative;
      width: fit-content;
      border: none;
      padding: 4px 4px 2px 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 1.1rem;
        color: var(--primary-color);
      }
    }
  }
}
</style>
